import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// The catalog index page keeps its filters (owner, kind, type, …) in the URL
// query. Opening an entity and coming back through the sidebar or a breadcrumb
// lands on a bare `/catalog`, so the filters were lost. This remembers the
// last filtered catalog query for the browser session and restores it when the
// page is opened without one. An explicit query (including a cleared filter
// set, which still carries `filters[kind]`) always wins and is remembered.
const STORAGE_KEY = 'launchpad.catalog.lastQuery';

const read = (): string | null => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

const write = (query: string): void => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, query);
  } catch {
    /* storage unavailable: nothing to remember */
  }
};

export const RememberCatalogFilters = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const query = location.search;

  useEffect(() => {
    if (query) write(query);
  }, [query]);

  if (!query) {
    const last = read();
    // Redirect before the catalog page mounts: it reads filters from the URL once.
    if (last) return <Navigate replace to={{ pathname: location.pathname, search: last }} />;
  }
  return <>{children}</>;
};
